import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, retry } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Arquivo } from '../model/arquivo';
import { Empresa } from '../model/empresa';
import { Image } from '../model/image.model';
import { Pessoa } from '../model/pessoa';
import { Timeline } from '../model/timeline';
@Injectable({
  providedIn: 'root',
})
export class BackendApiService {
  private backendUrl =
    environment.backend.base_url +
    environment.backend.project_suffix +
    environment.backend.project_name;

  private apikey = '7yOZAmFPCdzOSJ08Ia5yet2kKw270ZpsH0lb9YhK';
  private MAX_RETRY = 3;  
  requestOptions = {
    headers: { 'xc-token': `${this.apikey}` },
  };

  constructor(private router: Router, private http: HttpClient) { }


  convertToImageArray(imageArray: any): Array<Image> {
    if (!imageArray) {
      return [
        new Image().deserialize({
          path: '/assets/imagens/sem-logo.png',
          title: 'Sem Logo',
        }),
      ]
    }
    return imageArray.map((i: any) => {
      let path = ''
      if(i.path) path = environment.backend.base_url + '/' + i.path;
      return new Image().deserialize({
        path: path,
        url: i.url,
        signedUrl: i.signedUrl,
        title: i.title,
        mimetype: i.mimetype,
        size: i.size
      })
    });
  }

  getEmpresa(filter: string): Observable<Array<Empresa>> {


    return this.http.get<any>(
      `${this.backendUrl}/mxw7rqrhsszeea0/records${filter}`,
        this.requestOptions
      ).pipe(
      retry(this.MAX_RETRY),
      map((res: any) => {
        return res.list.map((r: any) => {
          return new Empresa().deserialize({
            id: r.Id,
            nome: r.nome,
            ativo: r.ativo,
            link: r.link,
            imagens: this.convertToImageArray(r.imagem),
            tipo: r.tipo
          })
                  })
      })
    )
  }
  findAllEmpresa<Empresa>(  
    tipo: string,
  ): Observable<Array<Empresa>> {
    let whereClause = `(ativo,eq,1)~and(tipo,eq,${tipo})`;

    const params = new HttpParams()
      .set('limit', '100')
      .set('sort', 'nome')
      .set('where', whereClause);

    return this.http
      .get<any>(`${this.backendUrl}/empresa`, {...this.requestOptions, params})
      .pipe(
        retry(this.MAX_RETRY),
        map((vaquinha: any) => {
          let empresas = vaquinha?.list?.map((r: any) => {
            return new Empresa().deserialize({
              id: r.Id,
              nome: r.nome,
              ativo: r.ativo,
              link: r.link,
              imagens: this.convertToImageArray(r.icone),
            });
          });
          return empresas;
        })
      );
  }

  findAllEmpresaMantenedora(): Observable<Array<Empresa>> {
    return this.findAllEmpresa<Empresa>('mantenedora');
  }

  findAllEmpresaParceiras(): Observable<Array<Empresa>> {
    return this.findAllEmpresa<Empresa>('parceira');
  }

  findAllEmpresaGraduada(): Observable<Array<Empresa>> {
    return this.findAllEmpresa<Empresa>('graduada');
  }

  findAllEmpreeendimentoPreIncubado(): Observable<Array<Empresa>> {
    return this.findAllEmpresa<Empresa>('pre-incubada');
  }

  findAllEmpresaIncubada(): Observable<Array<Empresa>> {
    return this.findAllEmpresa<Empresa>('incubada');
  }

  findAllAcontecimento(): Observable<Array<Timeline>> {
    const params = new HttpParams()
      .set('limit', '100')
      .set('sort', 'nome')
      .set('where', '(ativo,eq,1)');

    return this.http
      .get<any>(`${this.backendUrl}/timeline`, 
        {...this.requestOptions, params})
      .pipe(
        retry(this.MAX_RETRY),
        map((res: any) => {
          let resultado = res.list.map((registro: any) => {
            return new Timeline().deserialize({
              id: registro.Id,
              ano: registro.ano,
              ativo: registro.ativo,
              acontecimento: registro.acontecimento,
            });
          });
          return resultado;
        })
      );
  }
  findAllMentor(): Observable<Array<Pessoa>> {
    const params = new HttpParams()
      .set('limit', '100')
      .set('sort', 'nome')
      .set('where', '(ativo,eq,1)~and(funcao,like,mentor)');

    return this.http
      .get<any>(
        `${this.backendUrl}/colaborador`,
        {...this.requestOptions, params}
      )
      .pipe(
        retry(this.MAX_RETRY),
        map((res: any) => {
          return res.list.map((json: any) => {
            new Array<Image>();
            return new Pessoa().deserialize({
              id: json.Id,
              nome: json.nome,
              sobre: json.sobre,
              expertises: json.nc_i5qm___nc_m2m_nc_i5qm__colabo_nc_i5qm__experts,
              ativo: json.ativo,
              imagens: this.convertToImageArray(json.foto),
            });
          });
        })
      )
      
  
  }

  findAllColaboradores(): Observable<Array<Pessoa>> {
    let filter = '';
    filter += '?limit=100';
    filter += '&sort=nome';
    filter += '&where=(ativo,eq,1)';

    return this.http
      .get<any>(
        `${this.backendUrl}/colaborador${filter}`,
        this.requestOptions
      )
      .pipe(
        retry(this.MAX_RETRY),
        map((res: any) => {
          return res.list.map((json: any) => {
            return new Pessoa().deserialize({
              id: json.Id,
              ativo: json.ativo,
              nome: json.nome,
              imagens: this.convertToImageArray(json.foto),
            });
          });
        })
      );
  }

  findAllArquivos(): Observable<Array<Arquivo>> {
    const params = new HttpParams()
      .set('limit', '100')
      .set('sort', 'nome')
      .set('where', '(ativo,eq,1)');

    return this.http
      .get<any>(`${this.backendUrl}/arquivo`, {
        ...this.requestOptions,
        params,
      })
      .pipe(
        retry(this.MAX_RETRY),
        map((res: any) => {
          return res.list.map((json: any) => {
            return new Arquivo().deserialize({
              nome: json.nome,
              descricao: json.descricao,
              ativo: json.ativo,
              anexo: json.anexo,
            });
          });
        })
      );
  }

  getArquivoDownloadUrl(anexo: any): string {
    if (!anexo || !anexo.length) return '';
    const file = anexo[0];
    if (file.signedUrl) return file.signedUrl;
    if (file.path)
      return environment.backend.base_url + '/' + file.path;
    return file.url || '';
  }

  findAllDiretoria(): Observable<Array<Pessoa>> {
    let filter = '';
    filter += '?limit=100';
    filter += '&where=(ativo,eq,1)';

    return this.http
      .get<any>(
        `${this.backendUrl}/diretoria${filter}`,
        this.requestOptions
      )
      .pipe(
        retry(this.MAX_RETRY),
        map((res: any) => {
          return res.list.map((json: any) => {
            return new Pessoa().deserialize({
              id: json.Id,
              ativo: json.ativo,
              nome: json.nome,
              sobre: json.sobre,
              imagens: this.convertToImageArray(json.foto),
            });
          });
        })
      );
  }
}
